import { Injectable } from '@angular/core';
import { TrackTypes } from '../../shared/service/journey/tracks/model/track-types';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { MaritalStatus } from '../model/marital-status-data';

@Injectable({
  providedIn: 'root'
})
export class MaritalStatusService {

  private readonly STEP_CODE = 'marital-status';
  maritalStatusPrevious: string;
  maritalStatusNamePrevious: string;

  constructor(private journeyService: JourneyService) {
  }

  public setStatusName(statusName: string, statusCode: string, save: boolean) {
    if (!save || save && (statusCode !== '608' && statusCode !== '612')) {
      this.journeyService.registratioJourney.data.maritalStatus.maritalStatusName = statusName;
    } else {
      this.maritalStatusNamePrevious = this.journeyService.registratioJourney.data.maritalStatus.maritalStatusName;
      this.journeyService.registratioJourney.data.maritalStatus.maritalStatusName = statusName;
    }
  }

  public setStatus(status: string, save: boolean) {
    if (save && (status !== '608' && status !== '612')) {
      this.journeyService.registratioJourney.data.maritalStatus.maritalStatus = status;
      this.journeyService.registratioJourney.data.maritalStatus.spouseName = undefined;
      this.journeyService.registratioJourney.data.maritalStatus.spouseCpf = undefined;
      this.journeyService.registratioJourney.data.maritalStatus.foreignSpouse = false;
      this.setIsCompleteStepData();
      this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.maritalStatus);
      this.maritalStatusPrevious = undefined;
    } else {
      this.maritalStatusPrevious = this.journeyService.registratioJourney.data.maritalStatus.maritalStatus;
      this.journeyService.registratioJourney.data.maritalStatus.maritalStatus = status;
    }
  }

  public setNameSpouse(spouseName: string) {
    this.journeyService.registratioJourney.data.maritalStatus.spouseName = spouseName;
  }

  public setCpfSpouse(spouseCpf: string) {
    this.journeyService.registratioJourney.data.maritalStatus.spouseCpf = spouseCpf;
    this.maritalStatusPrevious = undefined;
    this.maritalStatusPrevious = undefined;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.maritalStatus);
  }

  public setForeignSpouse(foreignSpouse: boolean) {
    this.journeyService.registratioJourney.data.maritalStatus.foreignSpouse = foreignSpouse;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.maritalStatus);
  }

  setIsCompleteStepData() {
    this.journeyService.registratioJourney.data.maritalStatus.isCompleted = this.maritalStatusDataIsComplete();
  }

  maritalStatusDataIsComplete(): boolean {
    const idMarital = this.journeyService.registratioJourney.data?.maritalStatus?.maritalStatus;
    const idRequMarital = ['608', '612'];
    const filterMarital = idRequMarital.find(x => x === idMarital);

    return (this.journeyService.registratioJourney.data.maritalStatus !== undefined && filterMarital === undefined)
      || (this.journeyService.registratioJourney.data.maritalStatus !== undefined && filterMarital !== undefined
        && this.journeyService.registratioJourney.data.maritalStatus.spouseName?.length > 0
        && this.journeyService.registratioJourney.data.maritalStatus.foreignSpouse)
      || (this.journeyService.registratioJourney.data.maritalStatus !== undefined && filterMarital !== undefined
        && this.journeyService.registratioJourney.data.maritalStatus.spouseName?.length > 0
        && this.journeyService.registratioJourney.data.maritalStatus.spouseCpf?.length > 0
        && !this.journeyService.registratioJourney.data.maritalStatus.foreignSpouse);
  }

}
